import React from 'react';
import './index.css';
import { getImage } from '../../api/client'

import CardMedia from '@material-ui/core/CardMedia';

class ImageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imageUrl: "",
        }

    }

    componentDidMount() {
        this.getDownloadUrl()
    }

    getDownloadUrl = () => {
        this.props.fileName
            ? getImage(this.props.fileName).then(url =>
                this.setState({ imageUrl: url }))
            : this.setState({ imageUrl: "./img/niema.jpg" })
    }

    render() {
        return (
            this.state.imageUrl
                ? <CardMedia
                    className="media"
                    image={this.state.imageUrl}
                    title={this.props.title}
                />
                : <img className="placeholder" src="./img/placeholder.png" alt="loading"></img>
        )
    }
}

export default ImageComponent
